import { IconProps } from "../../utils/global-types/global-types";

const StudentIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_6997_97296)">
        <path
          fillRule="evenodd"
          d="M14.275 8.574V4.11h1.217v4.463a.609.609 0 0 1-1.217 0"
          clipRule="evenodd"
        ></path>
        <path d="M12.246 7.357V4.922H5.754v2.435a3.246 3.246 0 0 0 6.492 0"></path>
        <path d="m2.531 3.74 5.48-2.436c.63-.28 1.349-.28 1.978 0l5.48 2.436a.406.406 0 0 1 0 .741L9.99 6.917c-.63.28-1.348.28-1.977 0l-5.48-2.436a.406.406 0 0 1 0-.741M10.866 11.738l-1.29 1.304a.81.81 0 0 1-1.153 0l-1.29-1.304a.77.77 0 0 0-.76-.207c-2.277.67-3.865 2.182-3.865 3.94 0 .897.726 1.623 1.623 1.623h9.737c.897 0 1.623-.726 1.623-1.623 0-1.758-1.588-3.27-3.864-3.94a.77.77 0 0 0-.761.207"></path>
      </g>
      <defs>
        <clipPath id="clip0_6997_97296">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default StudentIcon;
